export default __webpack_public_path__ + "static/media/avatars(2).351f220c.png";